import React, {memo} from 'react';
import Modal from 'react-modal';
import './Modal.less';

import * as PropTypes from 'prop-types';

function ModalNew({
  className, isOpen, onHide, backdrop, children,
}) {
  return (
    <Modal
      className={className}
      isOpen={isOpen}
      onHide={onHide}
      backdrop={backdrop}
    >
      {backdrop && (<div role="button" className="modal-backdrop" onClick={onHide} />)}
      <div className="modal-main-content">
        {children}
      </div>
    </Modal>
  );
}

ModalNew.propTypes = {
  className: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  backdrop: PropTypes.bool,
  onHide: PropTypes.func,
};

ModalNew.defaultProps = {
  className: '',
  onHide: null,
  backdrop: true,
};

export default memo(ModalNew);
